import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { ChampionsTournamentWidgetDataType, WidgetEntry } from '../types';

const TOC_WIDGET_KEY = 'championsTournament';

export function useChampionsTournamentWidgets() {
  const { tournamentOfChampionsStore } = useStores();
  const { shouldShowWidget, tournamentOfChampions } = tournamentOfChampionsStore;

  return useMemo((): WidgetEntry<'championsTournament'>[] => {
    if (!shouldShowWidget || !tournamentOfChampions) return [];

    const data: ChampionsTournamentWidgetDataType = {
      key: TOC_WIDGET_KEY,
      dataTestId: 'champions-tournament-widget',
    };
    return [{ data, type: 'championsTournament', id: TOC_WIDGET_KEY }];
  }, [shouldShowWidget, tournamentOfChampions]);
}
